import { Environment } from '@environments/environment-type';
import packageInfo from '../../package.json';

export const environment: Environment = {
  name: 'Production',
  strapiUrl: 'https://api.hmskort.no',
  loginUrl: 'https://admin.hmskort.no',
  wordpressUrl: 'https://hmskort.no/hms-wordpress/api/v1',
  feedbackAppId: '39CC00F6-7C69-4E21-A06B-25F696E61494',
  puzzel: {
    configId: '941fdfc8-abe3-4dfc-8f53-b0082333bbb9',
    customerKey: '40701'
  },
  sentry: {
    dsn: 'https://84cb5447e3624ac393b15b5c93adb00c@sentry.tecs.no/43',
    environment: 'production',
    tracesSampleRate: 0.1,
    tracePropagationTargets: [/^https\/\/:hmskort.no/, /^\//]
  },
  analytics: {
    url: 'https://analytics.tecs.no',
    siteId: '1',
    enabled: true
  },
  version: packageInfo.version,
  logToConsole: false,
  cloudflareTurnstile: {
    siteKey: '0x4AAAAAAA1H245tNqG4UzZO',
    theme: 'light'
  }
};
